import { render, staticRenderFns } from "./AccessoryCard.vue?vue&type=template&id=2f4bfa22&scoped=true&"
import script from "./AccessoryCard.vue?vue&type=script&lang=js&"
export * from "./AccessoryCard.vue?vue&type=script&lang=js&"
import style0 from "./AccessoryCard.vue?vue&type=style&index=0&id=2f4bfa22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4bfa22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f4bfa22')) {
      api.createRecord('2f4bfa22', component.options)
    } else {
      api.reload('2f4bfa22', component.options)
    }
    module.hot.accept("./AccessoryCard.vue?vue&type=template&id=2f4bfa22&scoped=true&", function () {
      api.rerender('2f4bfa22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/AccessoryCard.vue"
export default component.exports